export default __webpack_public_path__ + "static/blackberry-lemonade-e77f85b4febc37703d30f38eaf533c51.png";